import { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

/**
 * Синхронизирует активную вкладку раздела админки с URL.
 *
 * URL-схема: /admin/<section>/<tab>. Первая вкладка — каноничный URL без
 * сегмента (/admin/<section>), остальные добавляют слаг (/admin/<section>/<slug>).
 * Неизвестный слаг нормализуется к первой вкладке.
 *
 * @param {string[]} tabs массив слагов вкладок по порядку, напр. ["subscriptions", "statistics"]
 * @returns {[number, (index: number) => void]} индекс активной вкладки и функция переключения
 */
export function useTabRoute(tabs) {
  const { section, tab } = useParams();
  const history = useHistory();

  const matchedIndex = tab ? tabs.indexOf(tab) : 0;
  const activeIndex = matchedIndex >= 0 ? matchedIndex : 0;

  // Неизвестный слаг вкладки -> первая вкладка (чистый URL раздела)
  useEffect(() => {
    if (tab && tabs.indexOf(tab) === -1) {
      history.replace(`/admin/${section}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, section]);

  const selectTab = (index) => {
    if (index === activeIndex) return;
    history.push(index === 0 ? `/admin/${section}` : `/admin/${section}/${tabs[index]}`);
  };

  return [activeIndex, selectTab];
}
